import React, { Component } from 'react';

import { getJson } from '../../helpers/RequestsHelper';
import { withTranslation } from 'react-i18next';
import PropertyItem from './PropertyItem';

class PropertySelectorComponent extends Component {

    state = {
        loading: true,
        error: true,
        selected: undefined,
        selectedId: undefined,
        items: []
    }

    constructor() {
        super()
        this.fillProperties = this.fillProperties.bind(this)
        this.onSelect = this.onSelect.bind(this)
    }

    componentDidMount() {
        this.fillProperties();
    }
    componentWillUnmount() {
        this._isUnmounted = true;
    }

    static getDerivedStateFromProps(props, state) {
        if (!state.selected) {
            state.selectedId = props.selected
        }
        return state
    }

    componentDidUpdate(nextProps) {
        const { path } = this.props
        if (nextProps.path !== path) {
            this.setState({ loading: true, items: undefined, selected: undefined });
            this.fillProperties()
        }
    }

    async fillProperties() {
        let items = this.props.items
        if (!items) {
            const json = await getJson(process.env.REACT_APP_SERVER_BASE_URL + this.props.path)
            //TODO: Can we cancel the request on unmount?
            if (this._isUnmounted) {
                return
            }
            if (json.error === "fail") {
                this.setState(({ error: true, loading: false }))
                this.onSelect(undefined)
                return
            }
            if (json.items && json.items.length == 0) {
                this.setState(({ empty: true, loading: false }))
                this.onSelect(undefined)
                return
            }

            const mapping = this.props.mapping
            if (mapping) {
                if (mapping.itemsField) {
                    items = json[mapping.itemsField]
                } else {
                    items = json.items
                }

                if (items && mapping.itemId) {
                    items = items.map(a => { return { id: a[mapping.itemId], name: a[mapping.itemName] } })
                }
            } else {
                items = json.items
            }
        }

        if (items && items.length >= 1) {
            let selected
            if (this.state.selectedId) {
                var findItem = items.find(a => a.id === this.state.selectedId)
                if (findItem) {
                    selected = findItem
                } else {
                    selected = items[0]
                }
            } else {
                selected = items[0]
            }

            this.setState(({ error: false, items, loading: false }))
    
            this.onSelect(selected)
        }
    }

    onSelect(property) {
        if (property) {
            this.setState({ selected: property, selectedId: property.id })         
            this.props.onSelect(property.id)
        } else {
            this.setState({ selected: undefined, selectedId: undefined })            
            this.props.onSelect(undefined)
        }
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return (<div>{t("loading")}</div>)
        }

        if (this.state.error) {
            return (<div>{t("errormessagetryagain")}<input type="button" className="submit-btn-2" value={t("btntryagain")} readOnly={true} onClick={this.fillProperties} /></div>)
        } 
        if (this.state.empty) {
            return (<div>{t("errormessageempty")}<input type="button" className="submit-btn-2" value={t("btntryagain")} readOnly={true} onClick={this.fillProperties} /></div>)
        } 
        let renderItems = []
        for (let index = 0; index < this.state.items.length; index++) {
            const item = this.state.items[index];
            renderItems.push(
                <PropertyItem item={item} key={item.id} onClick={this.onSelect} selected={this.state.selected === item} />
            )
        }

        return renderItems.length > 0 ? <div key={this.state.selected}>
            <div className="dropdown show">
                <button className="dropdown-toggle filter_selector" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {this.state.selected ? this.state.selected.name : ""}
                </button>

                <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    {renderItems}
                </div>
            </div>
        </div> :
            <div>{t("no_results")}</div>
    }

}
export default withTranslation()(PropertySelectorComponent)
